import Vue from "vue";
Vue.mixin({
    methods: {
        deg2rad(deg) {
            return deg * (Math.PI / 180);
        },
        getDistanceFromLatLon(lat1, lon1, lat2, lon2) {
            // https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
            // const R = 6371; // Radius of the earth in km
            const R = this.$store.getters.agencyDistanceUnit === 'km' ? 6371 : 3959; // Radius of the earth in mi
            const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
            const dLon = this.deg2rad(lon2 - lon1);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(lat1)) *
                Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            // Distance in km
            return R * c;
        },
        distanceBetweenCandidateJob(candidate, job) {
            if (
                candidate.user_latitude &&
                candidate.user_longitude &&
                job.latitude &&
                job.longitude
            ) {
                const dist = this.getDistanceFromLatLon(
                    Number(candidate.user_latitude),
                    Number(candidate.user_longitude),
                    Number(job.latitude),
                    Number(job.longitude)
                );
                // console.log(dist)
                return this.roundNumberTwoDigits(dist);
            } else {
                // return 'Could not compute'
                return null;
            }
        },
        calcEval(str) {
            try {
                return eval(str);
            } catch (error) {
                const subject = this.formatContent(
                    this.$store.getters.errorCalculatingPrice.subject,
                    this.$store.getters.agencyID,
                );
                const message = this.formatContent(
                    this.$store.getters.errorCalculatingPrice.message,
                    this.$store.getters.agencyID,
                    this.$store.getters.userID,
                    str,
                    String(error)
                );
                this.sendBackgroundEmailToEnginehire(subject, message, ["support@enginehire.ca"]);
                throw error;
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/calculation.js